
import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';



import {
  cuponFailure,
  cuponRequest,
  cuponSuccess,
  subscriptionFailure, subscriptionRequest, subscriptionSuccess,
  highlightedIdFailure, highlightedIdSuccess, highlightedIdRequest, resetHighlightedId,
  userFailure, userSuccess, userRequest,
  affiliateSuccess, affiliateRequest, affiliateFailure,
  modelsSuccess, modelsRequest, modelsFailure,
} from '../reducer/DataReducer';
import Constant from '../../Components/Utils/Constant';
import { getApi } from '../../Components/Utils/Apirequest';

// let getItem = state => state.AuthReducer;
// let token = '';

// subscription Data
export function* subscriptionSaga(action) {

  try {

    const token = localStorage?.getItem('token');
    let header = {
      'Authorization': `Bearer ${token}`
    };


    let response = yield call(getApi, 'subscription/getSubscriptionAccess', { header });  // api call

    console.log(header, "header");
    if (response?.status == 200) {
      yield put(subscriptionSuccess(response?.data));
      //  Toast(response?.data?.message);
    } else {
      yield put(subscriptionFailure(response?.error));
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(subscriptionFailure(error));
    // Toast(error?.response?.data?.message);
  }
}

//cupon Data
export function* cuponSaga(action) {

  try {

    const token = localStorage?.getItem('token');
    let header = {
      'Authorization': `Bearer ${token}`
    };
    let response = yield call(getApi, 'cupon/getCuponAccess', { header });

    console.log(header, "header1");
    if (response?.status == 200) {
      yield put(cuponSuccess(response?.data));
      //  Toast(response?.data?.message);
    } else {
      yield put(cuponFailure(response?.error));
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(cuponFailure(error));
    // Toast(error?.response?.data?.message);
  }
}

//highlightedId Data
export function* highlightedIdSaga(action) {

  try {
    if (action?.status == 200) {
      yield put(highlightedIdSuccess(action?.payload));
      //  Toast(response?.data?.message);
    } else {
      yield put(highlightedIdFailure(action?.error));
      yield put(resetHighlightedId());
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(highlightedIdFailure(error));
    yield put(resetHighlightedId());
    // Toast(error?.response?.data?.message);
  }
}

//user Data
export function* userSaga(action) {

  try {

    const token = localStorage?.getItem('token');
    let header = {
      'Authorization': `Bearer ${token}`
    };
    let response = yield call(getApi, 'user/get', { header });

    if (response?.status == 200) {
      yield put(userSuccess(response?.data));
      //  Toast(response?.data?.message);
    } else {
      yield put(userFailure(response?.error));
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(userFailure(error));
    // Toast(error?.response?.data?.message);
  }
}

//affiliate Data
export function* affiliateSaga(action) {

  try {

    const token = localStorage?.getItem('token');
    let header = {
      'Authorization': `Bearer ${token}`
    };
    let response = yield call(getApi, 'affiliate/get', { header });

    if (response?.status == 200) {
      yield put(affiliateSuccess(response?.data));
      //  Toast(response?.data?.message);
    } else {
      yield put(affiliateFailure(response?.error));
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(affiliateFailure(error));
    // Toast(error?.response?.data?.message);
  }
}

//models Data
export function* modelsSaga(action) {

  try {

    const token = localStorage?.getItem('token');
    let header = {
      'Authorization': `Bearer ${token}`
    };
    let response = yield call(getApi, 'model/get', { header });

    if (response?.status == 200) {
      yield put(modelsSuccess(response?.data));
      //  Toast(response?.data?.message);
    } else {
      yield put(modelsFailure(response?.error));
      // Toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    yield put(modelsFailure(error));
    // Toast(error?.response?.data?.message);
  }
}

const watchFunction = [

  (function* () {
    yield takeLatest('Data/subscriptionRequest', subscriptionSaga);
  })(),
  (function* () {
    yield takeLatest('Data/cuponRequest', cuponSaga);
  })(),
  (function* () {
    yield takeLatest('Data/highlightedIdRequest', highlightedIdSaga);
  })(),
  (function* () {
    yield takeLatest('Data/userRequest', userSaga);
  })(),
  (function* () {
    yield takeLatest('Data/affiliateRequest', affiliateSaga);
  })(),
  (function* () {
    yield takeLatest('Data/modelsRequest', modelsSaga);
  })(),
];

export default watchFunction;
